<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc">Contents</h1>
<p class="toc2"><a class="hlink" href="#/OEBPS/9780795325090_epub_atn_r1.htm">Author’s Note</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/9780795325090_epub_p01_r1.htm">Part One: The Apprentice</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c01_r1.htm">One</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c02_r1.htm">Two</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c03_r1.htm">Three</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c04_r1.htm">Four</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c05_r1.htm">Five</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c06_r1.htm">Six</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c07_r1.htm">Seven</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c08_r1.htm">Eight</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c09_r1.htm">Nine</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c10_r1.htm">Ten</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c11_r1.htm">Eleven</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/9780795325090_epub_p02_r1.htm">Part Two: The Warden</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c12_r1.htm">Twelve</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c13_r1.htm">Thirteen</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c14_r1.htm">Fourteen</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c15_r1.htm">Fifteen</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c16_r1.htm">Sixteen</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c17_r1.htm">Seventeen</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/9780795325090_epub_p03_r1.htm">Part Three: The Bureaucrat</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c18_r1.htm">Eighteen</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c19_r1.htm">Nineteen</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c20_r1.htm">Twenty</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c21_r1.htm">Twenty-One</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c22_r1.htm">Twenty-Two</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c23_r1.htm">Twenty-Three</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c24_r1.htm">Twenty-Four</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795325090_epub_c25_r1.htm">Twenty-Five</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795325090_epub_toc_r1.vue?346de84f